<template>
    <div class="dropdown" ref="selectContainer" :class="{ 'relative z-50': isDropdownOpen }">
        <div class="dropdown dropdown-end">
            <div
                tabindex="0"
                role="button"
                class="btn btn-sm"
                @click="toggleDropdown"
            >
                <!-- 下拉按钮图标 -->
                <svg t="1735448632254" class="icon h-6 w-6 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5701" width="200" height="200"><path d="M227.14123 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C321.728492 456.087573 279.288914 413.647995 227.14123 413.647995z"></path><path d="M510.903016 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C605.490278 456.087573 563.051723 413.647995 510.903016 413.647995z"></path><path d="M794.665825 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C889.253086 456.087573 846.813508 413.647995 794.665825 413.647995z" p-id="5704"></path></svg>
            </div>
            <ul
                v-if="isDropdownOpen"
                tabindex="0"
                :class="['dropdown-content menu bg-base-100 rounded-box z-10 w-52 p-2 shadow !leading-3',
                                         dropdownDirection === 'up' ? 'bottom-full' : 'top-full']"
                @click.stop=""
                @blur="closeDropdown"
            >
                <li><a @click.stop="handleSetNextInQueue(item)">
                    <svg t="1735703541751" class="h-4 w-4 fill-current" viewBox="0 0 1077 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2440" width="200" height="200"><path d="M363.789474 116.304842h646.736842a40.421053 40.421053 0 1 1 0 80.842105h-646.736842a40.421053 40.421053 0 1 1 0-80.842105z m-323.368421 397.473684h970.105263a40.421053 40.421053 0 1 1 0 80.842106h-970.105263a40.421053 40.421053 0 1 1 0-80.842106z m0 397.473685h970.105263a40.421053 40.421053 0 1 1 0 80.842105h-970.105263a40.421053 40.421053 0 1 1 0-80.842105zM0 26.947368A26.947368 26.947368 0 0 1 44.085895 6.197895l163.678316 135.114105a26.947368 26.947368 0 0 1 0 41.552842L44.085895 318.032842A26.947368 26.947368 0 0 1 0 297.283368V26.947368z"></path></svg>
                    添加下一首
                </a></li>
                <li><a @click.stop="handleAddToQueue(item)">
                    <svg t="1735703437172" class="h-4 w-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2287" width="200" height="200"><path d="M938.8 555.5c-12.8-27.7-30.4-52.7-51.7-73.9-2.4-2.2-4.8-4.4-7.1-6.8-15.5-16-26.8-35.9-32.1-58.1-0.9-3.3-1.5-6.6-2-10-1.6-9.6-2.1-19.7-1.3-29.8 1.7-22.4 9.2-43 20.8-60.4-47.7 6.3-87.8 39.3-103.2 84.6-1.1 3.4-2.2 6.9-3 10.5l-22.2 290c-6.4-2.6-12.9-4.9-19.8-6.7-11.7-3.3-24.1-5.7-37-7.1-14.9-1.6-30.5-1.7-46.6-0.1-34.1 3.2-65.2 13.3-90.8 27.9-28.9 16.5-50.7 39-61.9 64.4-6.5 14.8-9.5 30.5-7.9 46.5 6.3 67.7 88.6 115.3 183.6 106.4 23.3-2.2 45.3-7.6 65-15.5 26.6-10.7 49.1-25.9 65.7-43.9 14.6-15.8 24.5-33.9 28.3-52.9 0.7-3.6 1.2-7.4 1.6-11.1 0.2 0 22-282.3 22-282.3 2.3 0.1 4.8 0.1 7.1 0.3 30.1 2.3 57 14.9 77.4 34.3 16.4 15.5 28.5 35.3 34.8 57.5-3.6-22.3-10.3-43.7-19.7-63.8z m-99.5-28.3zM105 169h798.2c22.1 0 40-17.9 40-40s-17.9-40-40-40H105c-22.1 0-40 17.9-40 40s17.9 40 40 40z"></path><path d="M105 551.8h568.2c22.1 0 40-17.9 40-40s-17.9-40-40-40H105c-22.1 0-40 17.9-40 40s17.9 40 40 40z m312.2 302.8H105c-22.1 0-40 17.9-40 40s17.9 40 40 40h312.2c22.1 0 40-17.9 40-40s-17.9-40-40-40z"></path></svg>
                    添加到队列
                </a></li>
                <li v-if="$route.name === 'playlist'"><a @click.stop="removePlayListFunc(index)">
                    <svg t="1735707198915" class="h-4 w-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5275" width="200" height="200"><path d="M635.904 29.809778c6.712889 0 13.368889 1.592889 19.569778 4.778666l6.030222 3.754667 4.551111 3.982222 181.930667 182.784a41.699556 41.699556 0 0 1 10.353778 17.180445l1.592888 6.940444 0.398223 5.973334v153.031111a42.496 42.496 0 0 1-83.171556 12.344889l-1.422222-6.144-0.512-6.200889V349.980444h-158.947556a76.231111 76.231111 0 0 1-72.590222-53.304888l-1.934222-7.395556-1.194667-7.623111-0.455111-7.793778V114.915556H146.033778a24.917333 24.917333 0 0 0-21.048889 11.548444l-2.104889 4.323556-1.137778 4.039111-0.341333 4.778666v738.986667c0 10.581333 6.712889 19.740444 15.815111 23.096889l4.039111 1.080889 4.778667 0.398222h604.615111a24.746667 24.746667 0 0 0 23.096889-15.872l1.137778-3.982222 0.341333-4.778667v-67.128889a42.496 42.496 0 0 1 83.228444-12.401778l1.422223 6.200889 0.455111 6.144v100.807111c0 36.295111-25.6 67.128889-60.700445 74.524445l-7.623111 1.137778-7.793778 0.455111H112.412444a76.231111 76.231111 0 0 1-74.524444-60.700445l-1.137778-7.623111-0.455111-7.793778V105.984c0-36.408889 25.6-67.185778 60.700445-74.524444L104.618667 30.151111l7.793777-0.398222h523.491556z m-20.707556 638.179555a42.496 42.496 0 0 1 12.344889 83.171556l-6.144 1.479111-6.200889 0.455111H212.195556a42.496 42.496 0 0 1-12.344889-83.171555l6.200889-1.479112 6.144-0.455111h403.057777z m280.291556-174.421333l5.290667 4.494222 81.521777 81.521778a40.391111 40.391111 0 0 1 8.135112 11.946667l-0.398223-1.137778 1.991111 4.437333a35.157333 35.157333 0 0 1 1.706667 6.769778l0.455111 3.925333v6.769778l0.455111-2.275555 0.113778 0.568888a40.846222 40.846222 0 0 1-1.024 8.305778l-1.592889 5.404445-1.991111 4.664889-3.527111 5.802666-4.323556 5.063111-81.521777 81.578667a42.496 42.496 0 0 1-60.245334 0 42.609778 42.609778 0 0 1-4.494222-54.954667l4.494222-5.290666 8.817778-8.874667h-165.888a42.496 42.496 0 0 1-40.903111-30.663111l-1.251556-6.087111-0.398222-5.745778c0-21.617778 15.928889-39.367111 36.750222-42.154667l5.802667-0.398222h166.001778l-8.931556-8.988444a42.666667 42.666667 0 0 1-7.964444-49.152l3.470222-5.745778 4.551111-5.290667a42.609778 42.609778 0 0 1 54.897778-4.551111z m-280.291556-27.136a42.496 42.496 0 0 1 12.344889 83.228444l-6.144 1.422223-6.200889 0.455111H212.195556a42.496 42.496 0 0 1-12.344889-83.171556l6.200889-1.422222 6.144-0.512h403.057777zM413.696 264.931556a42.496 42.496 0 0 1 12.344889 83.171555l-6.200889 1.422222-6.144 0.512H212.138667a42.496 42.496 0 0 1-12.344889-83.228444l6.200889-1.422222 6.144-0.455111h201.557333z m211.512889-137.386667v112.753778c0 10.638222 6.712889 19.797333 15.872 23.153777l3.982222 1.080889 4.778667 0.398223 112.696889-0.056889-137.329778-137.329778z"></path></svg>
                    移出播放列表
                </a></li>
                <li v-else><a @click.stop="handleAddPlaylist(item.id)">
                    <svg t="1699584409505" class="h-4 w-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2741" width="64" height="64"><path d="M896 853.333333H597.333333v-85.333333h298.666667z m0-256H597.333333v85.333334h298.666667z m0-170.666666H597.333333v85.333333h298.666667z m-213.333333-42.666667a256 256 0 0 1-170.666667-65.493333V704a192 192 0 1 1-85.333333-159.573333V128h85.333333a170.666667 170.666667 0 0 0 170.666667 170.666667zM426.666667 704a106.666667 106.666667 0 1 0-106.666667 106.666667 106.666667 106.666667 0 0 0 106.666667-106.666667z" p-id="2742"></path></svg>
                    添加到播放列表
                </a></li>
                <li v-if="isInQueue"><a @click.stop="handleRemoveFromQueue(index)">
                    <svg t="1735707198915" class="h-4 w-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5275" width="200" height="200"><path d="M635.904 29.809778c6.712889 0 13.368889 1.592889 19.569778 4.778666l6.030222 3.754667 4.551111 3.982222 181.930667 182.784a41.699556 41.699556 0 0 1 10.353778 17.180445l1.592888 6.940444 0.398223 5.973334v153.031111a42.496 42.496 0 0 1-83.171556 12.344889l-1.422222-6.144-0.512-6.200889V349.980444h-158.947556a76.231111 76.231111 0 0 1-72.590222-53.304888l-1.934222-7.395556-1.194667-7.623111-0.455111-7.793778V114.915556H146.033778a24.917333 24.917333 0 0 0-21.048889 11.548444l-2.104889 4.323556-1.137778 4.039111-0.341333 4.778666v738.986667c0 10.581333 6.712889 19.740444 15.815111 23.096889l4.039111 1.080889 4.778667 0.398222h604.615111a24.746667 24.746667 0 0 0 23.096889-15.872l1.137778-3.982222 0.341333-4.778667v-67.128889a42.496 42.496 0 0 1 83.228444-12.401778l1.422223 6.200889 0.455111 6.144v100.807111c0 36.295111-25.6 67.128889-60.700445 74.524445l-7.623111 1.137778-7.793778 0.455111H112.412444a76.231111 76.231111 0 0 1-74.524444-60.700445l-1.137778-7.623111-0.455111-7.793778V105.984c0-36.408889 25.6-67.185778 60.700445-74.524444L104.618667 30.151111l7.793777-0.398222h523.491556z m-20.707556 638.179555a42.496 42.496 0 0 1 12.344889 83.171556l-6.144 1.479111-6.200889 0.455111H212.195556a42.496 42.496 0 0 1-12.344889-83.171555l6.200889-1.479112 6.144-0.455111h403.057777z m280.291556-174.421333l5.290667 4.494222 81.521777 81.521778a40.391111 40.391111 0 0 1 8.135112 11.946667l-0.398223-1.137778 1.991111 4.437333a35.157333 35.157333 0 0 1 1.706667 6.769778l0.455111 3.925333v6.769778l0.455111-2.275555 0.113778 0.568888a40.846222 40.846222 0 0 1-1.024 8.305778l-1.592889 5.404445-1.991111 4.664889-3.527111 5.802666-4.323556 5.063111-81.521777 81.578667a42.496 42.496 0 0 1-60.245334 0 42.609778 42.609778 0 0 1-4.494222-54.954667l4.494222-5.290666 8.817778-8.874667h-165.888a42.496 42.496 0 0 1-40.903111-30.663111l-1.251556-6.087111-0.398222-5.745778c0-21.617778 15.928889-39.367111 36.750222-42.154667l5.802667-0.398222h166.001778l-8.931556-8.988444a42.666667 42.666667 0 0 1-7.964444-49.152l3.470222-5.745778 4.551111-5.290667a42.609778 42.609778 0 0 1 54.897778-4.551111z m-280.291556-27.136a42.496 42.496 0 0 1 12.344889 83.228444l-6.144 1.422223-6.200889 0.455111H212.195556a42.496 42.496 0 0 1-12.344889-83.171556l6.200889-1.422222 6.144-0.512h403.057777zM413.696 264.931556a42.496 42.496 0 0 1 12.344889 83.171555l-6.200889 1.422222-6.144 0.512H212.138667a42.496 42.496 0 0 1-12.344889-83.228444l6.200889-1.422222 6.144-0.455111h201.557333z m211.512889-137.386667v112.753778c0 10.638222 6.712889 19.797333 15.872 23.153777l3.982222 1.080889 4.778667 0.398223 112.696889-0.056889-137.329778-137.329778z"></path></svg>
                    移出队列
                </a></li>
                <li v-if="$route.name !== 'favourites'"><a @click.stop="addFavouriteTrack(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" :class="['h-4', 'w-4', item.favourite ? 'fill-current' : '']" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>
                    添加到喜爱
                </a></li>
                <li v-else><a @click.stop="addFavouriteTrack(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" :class="['h-4', 'w-4', item.favourite ? 'fill-current' : '']" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>
                    移出喜爱
                </a></li>
                <li v-if="isSuperuser"><a @click.stop="redirctEditDetailPage(item.path)">
                    <svg t="1702603778129" class="h-4 w-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3152" width="64" height="64"><path d="M862.709333 116.042667a32 32 0 1 1 45.248 45.248L455.445333 613.813333a32 32 0 1 1-45.258666-45.258666L862.709333 116.053333zM853.333333 448a32 32 0 0 1 64 0v352c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V224c0-64.8 52.533333-117.333333 117.333333-117.333333h341.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v576a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V448z"></path></svg>
                    操作台编辑
                </a></li>
                <li v-if="isSuperuser"><a @click.stop="redirctEditDetail(item.path)">
                    <svg t="1702603778129" class="h-4 w-4 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3152" width="64" height="64"><path d="M862.709333 116.042667a32 32 0 1 1 45.248 45.248L455.445333 613.813333a32 32 0 1 1-45.258666-45.258666L862.709333 116.053333zM853.333333 448a32 32 0 0 1 64 0v352c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V224c0-64.8 52.533333-117.333333 117.333333-117.333333h341.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v576a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V448z"></path></svg>
                    元数据编辑
                </a></li>
                <li v-if="isSuperuser"><a @click.stop="handleDeleteMusic(item.id)">
                    <svg class="icon fill-current w-4 h-4" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0H5V1.5L9 1.5V0ZM0 2.5H14V4H12.75V11.75C12.75 12.9927 11.7426 14 10.5 14L3.65821 14C2.41556 14 1.4082 12.9927 1.4082 11.75V4H0V2.5ZM2.9082 4H11.25V11.75C11.25 12.1642 10.9142 12.5 10.5 12.5L3.6582 12.5C3.24399 12.5 2.9082 12.1642 2.9082 11.75V4ZM6.25 5.75V10.75H4.75V5.75H6.25ZM9.25 10.75V5.75H7.75V10.75H9.25Z"/>
                    </svg>
                    删除音乐
                </a></li>
            </ul>
        </div>
        
        <!-- 编辑抽屉 -->
        <div class="drawer drawer-end">
            <input id="track-edit" type="checkbox" class="drawer-toggle" v-model="isShowEdit" />
            <div class="drawer-side">
                <label for="track-edit" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">元数据编辑</div>
                        <button class="btn btn-sm btn-ghost" @click="isShowEdit = false">
                            <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                            </svg>
                        </button>
                    </div>
                    <div v-if="isShowEdit">
                        <music-meta-data 
                            :loading="editLoading" 
                            :reload-img="reloadImg"
                            :music-info="editMusicInfo"
                            :drawer-mode="'drawer'" 
                            @musicInfoSaved="handleMusicInfoSaved"
                        />
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 资源详情抽屉 -->
        <div class="drawer drawer-start">
            <input id="resource-id3" type="checkbox" class="drawer-toggle" v-model="isShowResourceId3" />
            <div class="drawer-side">
                <label for="resource-id3" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-[800px]">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">资源信息</div>
                        <button class="btn btn-sm btn-ghost" @click="isShowResourceId3 = false">
                            <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                            </svg>
                        </button>
                    </div>
                    <div v-if="isShowResourceId3">
                        <resource :song-list="songList" :section3-loading="resourceLoading"></resource>
                    </div>
                </div>
            </div>
        </div>
        
        <dialog ref="plist" class="modal">
            <div class="modal-box">
                <form method="dialog">
                    <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                </form>
                <h3 class="font-bold text-lg mb-4">添加至播放列表</h3>
                <div v-if="playLists.length > 0">
                    <select class="select select-bordered select-sm w-full max-w-xs" v-model="selectPlaylist">
                        <option v-for="(item, index) in playLists" :key="index" :value="item.id">{{item.name}}</option>
                    </select>
                    <button class="btn btn-sm ml-1" @click="addToPlaylistFunc">添加</button>
                </div>
                <div class="flex flex-col mb-4">
                    <button class="btn btn-sm mt-2 ml-1 w-32" @click="isShowCreatePlist = !isShowCreatePlist">新建播放列表</button>
                    <div v-if="isShowCreatePlist || playLists.length === 0" class="mt-1">
                        <input type="text" placeholder="请输入" class="input input-bordered input-sm w-full max-w-xs" v-model="plName" />
                        <button class="btn btn-sm ml-1" @click="createPlaylistFunc">添加</button>
                    </div>
                </div>
            </div>
        </dialog>
        <!-- Open the modal using ID.showModal() method -->
        <dialog ref="delete_music" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">删除音乐!</h3>
                <div class="py-4 text-gray-400">
                    <div>删除音乐: 将音乐从音乐收藏中移除，同时删除音乐文件。</div>
                    <div>删除收藏: 将音乐从音乐收藏中移除，但并不会删除音乐文件。</div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-sm mr-1 btn-error text-white" @click="deleteMusic('delete_file')">删除音乐</button>
                        <button class="btn btn-sm mr-1 btn-neutral" @click="deleteMusic('delete_track')">删除收藏</button>
                        <button class="btn btn-sm mr-1">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import MusicMetaData from '@/views/home/musicMetaData'
import Resource from '@/views/home/resource'
import {mapGetters} from 'vuex'

export default {
    name: "TrackAction",
    components: {
        MusicMetaData,
        Resource
    },
    props: {
        item: {type: Object, required: true},
        index: {type: Number, required: true},
    },
    data() {
        return {
            isShowCreatePlist: false,
            plName: '',
            playLists: [],
            selectTrackID: '',
            isDropdownOpen: false,
            dropdownDirection: 'down',
            isShowEdit: false,
            editLoading: false,
            editMusicInfo: {},
            isShowResourceId3: false,
            resourceLoading: false,
            songList: [],
            reloadImg: true
        }
    },
    computed: {
        ...mapGetters({
                isSuperuser: 'getIsSuperuser'
            }),
        selectPlaylist: {
            get() {
                const savedPlaylist = localStorage.getItem('lastSelectedPlaylist')
                // 检查保存的播放列表ID是否在当前播放列表中
                if (savedPlaylist && this.playLists.some(item => item.id === savedPlaylist)) {
                    return savedPlaylist
                }
                return ''
            },
            set(value) {
                localStorage.setItem('lastSelectedPlaylist', value)
            }
        },
        isInQueue() {
            const queue = this.$store.state.common.queue || []
            return queue.some(track => track.id === this.item.id)
        }
    },
    methods: {
        handleAddPlaylist(TrackID) {
            this.selectTrackID = TrackID
            this.isShowCreatePlist = false
            this.$api.subsonic.getPlaylists().then((res) => {
                this.playLists = res
            })
            this.$refs.plist.showModal()
        },
        createPlaylistFunc() {
            this.$api.subsonic.createPlaylist(this.plName, [this.selectTrackID]).then((res) => {
                this.$myMsg.notify({
                    title: '添加成功！',
                    type: 'success',
                    time: 2000,
                })
                this.$refs.plist.close()
            })
        },
        addToPlaylistFunc() {
            this.$api.subsonic.addToPlaylist(this.selectPlaylist, [this.selectTrackID]).then((res) => {
                this.$refs.plist.close()
                this.$myMsg.notify({
                    title: '添加成功！',
                    type: 'success',
                    time: 2000,
                })
            })
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
            if (this.isDropdownOpen) {
                this.$nextTick(() => {
                    this.adjustDropdownPosition();
                    // this.setRowZIndex(true)
                })
            } else {
                // this.setRowZIndex(false)
            }
        },
        adjustDropdownPosition() {
            const dropdownContent = this.$el.querySelector('.dropdown-content');
            const button = this.$el.querySelector('[role="button"]');
            const viewportHeight = window.innerHeight;
            const dropdownRect = dropdownContent.getBoundingClientRect();
            const buttonRect = button.getBoundingClientRect();

            // 检测下拉框是否超出视窗底部
            if (buttonRect.bottom + dropdownRect.height - 30 > viewportHeight) {
                // 如果空间不足，则添加向上展示的类
                this.dropdownDirection = 'up';
            } else {
                this.dropdownDirection = 'down';
            }
        },
        closeDropdown() {
            this.isDropdownOpen = false;
            // this.setRowZIndex(false)
        },
        setRowZIndex(active) {
            // 确保当前行在同层元素之上，避免被下一行覆盖
            try {
                const host = this.$el.closest('tr') || this.$el.closest('.card')
                if (!host) return
                if (active) {
                    host.classList.add('relative')
                    host.classList.add('z-50')
                } else {
                    host.classList.remove('z-50')
                    // 不强制移除 relative，避免影响已有布局
                }
            } catch (e) {
                // 安静失败
            }
        },
        handleSummaryClick(id) {
            // 处理summary点击事件的逻辑
            console.log('Summary clicked:', id);
            this.closeDropdown(); // 点击后关闭下拉菜单
        },
        removePlayListFunc(index) {
            this.$api.subsonic.removeFromPlaylist(this.$route.params.id, index).then((res) => {
                this.$myMsg.notify({
                    title: '删除成功！',
                    type: 'success',
                    time: 2000,
                })
                this.$parent.removeTrackFromPlaylist(index)
                this.closeDropdown()
            })
        },
        redirctEditDetailPage(path) {
            if (this.$route.name !== 'home') {
                this.$router.push({name: 'home'})
            }
            this.$store.commit('setFullPath', path)
        },
        redirctEditDetail(path) {
            this.editLoading = true
            this.isShowEdit = true
            this.closeDropdown()
            
            // 获取音乐元数据信息
            const pathParts = path.split('/')
            const fileName = pathParts.pop()
            const parentPath = pathParts.join('/')
            
            this.$api.Task.musicId3({ 'file_path': parentPath, 'file_name': fileName }).then((res) => {
                this.editLoading = false
                if (res.result) {
                    this.editMusicInfo = res.data
                    this.editMusicInfo.files1 = [{
                        name: 'cover.png',
                        status: 'done',
                        url: this.editMusicInfo.artwork
                    }]
                } else {
                    this.$myMsg.notify({
                        title: '获取音乐信息失败！',
                        content: res.message,
                        type: 'error',
                        time: 5000,
                    })
                    this.isShowEdit = false
                }
            }).catch(() => {
                this.editLoading = false
                this.isShowEdit = false
            })
        },
        addFavouriteTrack(item) {
            if (item.favourite) {
                this.$api.subsonic.removeFavourite(item.id, 'track').then((res) => {
                    item.favourite = false
                })
            } else {
                this.$api.subsonic.addFavourite(item.id, 'track').then((res) => {
                    item.favourite = true
                })
            }
            this.closeDropdown()
        },
        handleSetNextInQueue(item) {
            this.$store.commit('setNextInQueue', [item])
            this.closeDropdown()
            this.$myMsg.notify({
                title: '添加成功！',
                type: 'success',
                time: 2000,
            })
        },
        handleAddToQueue(item) {
            this.$store.commit('addToQueue', [item])
            this.closeDropdown()
            this.$myMsg.notify({
                title: '添加成功！',
                type: 'success',
                time: 2000,
            })
        },
        handleDeleteMusic() {
            this.$refs.delete_music.showModal()
        },
        deleteMusic(mode) {
            this.$api.Task.deleteTrack({'track_id': this.item.id, 'mode': mode}).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '删除成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.$parent.removeTrackFromPlaylist(this.index)
                }
            })
        },
        handleRemoveFromQueue(index) {
            const queue = this.$store.state.common.queue || []
            const trackIndex = queue.findIndex(track => track.id === this.item.id)
            if (trackIndex !== -1) {
                this.$store.commit('removeFromQueue', trackIndex)
                this.closeDropdown()
                this.$myMsg.notify({
                    title: '移出成功！',
                    type: 'success',
                    time: 2000,
                })
            }
        },
        
        handleMusicInfoSaved() {
            this.isShowEdit = false
            // 可以发出事件通知父组件更新列表
            this.$myMsg.notify({
                title: '保存成功！',
                type: 'success',
                time: 2000,
            })
        },
        handleClick() {
            this.isShowEdit = false
        },
        toggleLock(mode) {
            if (!this.editMusicInfo.title) {
                this.$myMsg.notify({
                    title: '标题不能为空！',
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 显示资源抽屉
            this.isShowResourceId3 = true
            this.resourceLoading = true
            
            const fullPath = this.item.path
            
            this.$api.Task.fetchId3Title({
                title: this.editMusicInfo.title,
                artist: this.editMusicInfo.artist,
                album: this.editMusicInfo.album,
                full_path: fullPath,
                resource: localStorage.getItem('resource') ? localStorage.getItem('resource') : 'netease'
            }).then((res) => {
                this.resourceLoading = false
                if (res.result) {
                    // 设置资源数据到songList
                    this.songList = res.data
                } else {
                    this.$myMsg.notify({
                        title: '获取资源信息失败！',
                        content: res.message,
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.resourceLoading = false
                this.$myMsg.notify({
                    title: '获取资源信息失败！',
                    type: 'error',
                    time: 2000,
                })
            })
        },
        handleCopy(k, v) {
            if (k === 'lyric') {
                const resource = localStorage.getItem('resource') ? localStorage.getItem('resource') : 'netease'
                const resurce = resource !== 'smart_tag' ? resource : v.resource
                this.$api.Task.fetchLyric({ 'song_id': v.id, 'resource': resurce }).then((res) => {
                    if (res.result) {
                        if (res.data !== '') {
                            this.editMusicInfo['lyrics'] = res.data
                            this.handleCopy('composer', this.editMusicInfo['lyrics'])
                        } else {
                            this.$myMsg.notify({
                                title: '未找到歌词！',
                                type: 'error',
                                time: 2000,
                            })
                        }
                    } else {
                        this.$myMsg.notify({
                            title: '未找到歌词！',
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
            } else if (k === 'composer') {
                this.$api.Task.extractLyric({ 'lyc': v }).then((res) => {
                    if (res.result) {
                        if (res.data !== '') {
                            this.editMusicInfo['composer'] = res.data.composer
                            this.editMusicInfo['lyricist'] = res.data.lyricist
                        }
                    }
                })
            } else if (k === 'album_img') {
                this.editMusicInfo[k] = ''
                this.editMusicInfo['artwork'] = v
                this.editMusicInfo['files1'] = [
                    {
                        name: 'new.png',
                        status: 'done',
                        url: v
                    }
                ]
            } else if (k === 'artist') {
                // 按照分隔符分割artist字符串
                if (typeof v === 'string') {
                    // 定义分隔符数组
                    const delimiters = [",", "\\", "&", "+", "|", "、", "，", ";", "ft.", "feat.", "Feat.","\u0000","\x00"];
                    // 构造正则表达式
                    const regex = new RegExp(delimiters.map(d => d.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
                    // 分割并去除首尾空格，过滤空字符串
                    this.editMusicInfo['artist_list'] = v.split(regex).map(s => s.trim()).filter(s => s);
                } else {
                    this.editMusicInfo['artist_list'] = v
                }
                this.editMusicInfo[k] = v
            } else {
                this.editMusicInfo[k] = v
            }
        },
        copyAll(item) {
            this.handleCopy('title', item.name)
            this.handleCopy('year', item.year)
            this.handleCopy('lyric', item)
            this.handleCopy('album', item.album)
            this.handleCopy('artist', item.artist)
            this.handleCopy('album_img', item.album_img)
            this.handleCopy('tracknumber', item.tracknumber)
            this.handleCopy('discnumber', item.discnumber)
            this.handleCopy('totaltracks', item.totaltracks)
            this.handleCopy('totaldiscs', item.totaldiscs)
        }
    }
}
</script>

<style scoped>
.menu.top-full {
    top: 100%;
}
.menu.bottom-full {
    bottom: 100%;
}
</style>
